module.exports = __webpack_public_path__ + "static/media/test20_4.fcdcc9c8.png";